import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import Investment from "../../pages/authorized/Investment";

const Private = () => {

    return (
        <Switch>
            <PrivateRoute exact path="/investment" component={Investment} />
            <Route component={PageError} />
        </Switch>
    )
};

export default Private;
